import React, { useState } from 'react';
import { CFTextField } from '..';
export const CFPasswordField = ({ allowUserToUnmask = true, disabled = false, fieldSize = 'md', iconLeft, id, name = 'password', nativeFieldProps, onChange, placeholder, showValidationBadge = true, validationState = 'default', value = '', }) => {
    const [showPassword, setShowPassword] = useState(false);
    return (React.createElement(CFTextField, { disabled: disabled, fieldSize: fieldSize, iconLeft: iconLeft, iconRight: allowUserToUnmask
            ? {
                iconLeft: showPassword ? 'eye' : 'eye-off-2',
                onClick: () => setShowPassword((showPassword) => !showPassword),
            }
            : undefined, id: id, maskInput: !showPassword, name: name, nativeFieldProps: nativeFieldProps, onChange: onChange, placeholder: placeholder, showValidationBadge: showValidationBadge, validationState: validationState, value: value }));
};
